import axios from "axios";

// Map provider settings saved by the super admin (Settings > Map settings).
// Loaded once and shared by every map component; call invalidate() after saving.
let configPromise = null;

function buildConfig(settings) {
  settings = settings || {};
  const provider = settings.map_provider === "mapbox" ? "mapbox" : "google";
  const googleKey = settings.google_maps_api_key || null;
  const mapboxToken = settings.mapbox_access_token || null;
  return {
    provider: provider,
    googleKey: googleKey,
    mapboxToken: mapboxToken,
    // false until the super admin saves a key for the selected provider
    configured: !!(provider === "mapbox" ? mapboxToken : googleKey),
  };
}

export default {
  getConfig() {
    if (configPromise == null) {
      configPromise = axios
        .get("/settings/user")
        .then((response) => buildConfig(response.data.settings))
        .catch((error) => {
          console.log(error);
          configPromise = null;
          return buildConfig(null);
        });
    }
    return configPromise;
  },
  invalidate() {
    configPromise = null;
  },
};
